import React from "react";
import "./Counter.css";

const Counter = () => {
  const data = [
    {
      count: "10+",
      title: "Years Experience",
      descn: "Improving homes with expert craftsmanship for years",
    },
    {
      count: "190+",
      title: "Projects Completed",
      descn: "Over 250 successful projects delivered with quality & care",
    },
    {
      count: "260+",
      title: "Skilled Tradespeople",
      descn: "Our team of 30 experts ensures top-quality results",
    },
    {
      count: "328+",
      title: "Client Satisfaction",
      descn: "All of our clients are satisfied with our work and service",
    },
  ];

  return (
    <section className="Counter">
      <div className="container">
        <div className="main_div">
          <div className="row">
            {data?.map((item) => {
              return (
                <div className="col-lg-3 col-sm-6 col-6 mb-3">
                  <div className="counter_div">
                    <div className="count_div">
                      <p className="count_text">{item?.count}</p>
                    </div>
                    <p className="heading">{item?.title}</p>
                    <p className="descn">{item?.descn}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="bottom_img_div">
          <img
            src="/assets/images/home/counter/img.png"
            className="bottom_img"
          />
        </div>
      </div>
    </section>
  );
};

export default Counter;
